import { css } from 'styled-components';
import {COLORS} from "../../../../shared/design/tokens";

const styles = {
  container: css`
    display: flex;
    flex: 1;
    width: 100%;
    flex-direction: column;

    .text {
      font-size: 18px;
      line-height: 28px;
    }

    a {
      color: ${COLORS.TEXT.SEA_BLUE};
    }
  `,
  content: css`
    padding: 40px 32px;
  `,
  title: css`
    display: flex;
    padding-bottom: 40px;
  `,
  iconContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;

  `
};

export default styles;
